/**
 * Maps an array of data items to a template.
 * @param {string[]} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapLanguageToTemplate = (results, $itemTemplate) => (
    results
        .map(lang => {
            const $item = $itemTemplate.clone();
            $item.find('input').attr('id', lang);
            $item.find('input').attr('name', lang);
            $item.find('input').val(lang);
            $item.find('label').attr('for', lang);
            $item.find('label').text(lang);

            return $item.get(0);
        })
);

export default mapLanguageToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/mapLanguageToTemplate.js